import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";

const LangContext = createContext();
const CartContext = createContext();

export const AppProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("co_lang") || "fr");
  const [cart, setCart] = useState(() => JSON.parse(localStorage.getItem("co_cart") || "[]"));

  useEffect(() => localStorage.setItem("co_lang", lang), [lang]);
  useEffect(() => localStorage.setItem("co_cart", JSON.stringify(cart)), [cart]);

  const toggleLang = useCallback(() => setLang((l) => (l === "fr" ? "en" : "fr")), []);

  const addToCart = useCallback((product) => {
    setCart((c) => {
      const found = c.find((i) => i.id === product.id);
      if (found) {
        if (product.is_unique) return c;
        return c.map((i) => (i.id === product.id ? { ...i, quantity: i.quantity + 1 } : i));
      }
      return [...c, { ...product, quantity: 1 }];
    });
  }, []);

  const removeFromCart = useCallback((id) => setCart((c) => c.filter((i) => i.id !== id)), []);
  const updateQty = useCallback((id, q) => setCart((c) => c.map((i) => (i.id === id ? { ...i, quantity: i.is_unique ? 1 : Math.max(1, q) } : i))), []);
  const clearCart = useCallback(() => setCart([]), []);

  const langValue = useMemo(() => ({ lang, toggleLang }), [lang, toggleLang]);
  const cartValue = useMemo(
    () => ({ cart, addToCart, removeFromCart, updateQty, clearCart }),
    [cart, addToCart, removeFromCart, updateQty, clearCart]
  );

  return (
    <LangContext.Provider value={langValue}>
      <CartContext.Provider value={cartValue}>
        {children}
      </CartContext.Provider>
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
export const useCart = () => useContext(CartContext);
